<template>
<div class="col-xs-12">
  <div class="card float-e-margins">
    <div class="card-title">
        <h1>Orders goedkeuren en verzendkosten invullen</h1>
    </div>
    <div class="card-content no-padding">
      <vc-alert v-if="success" type="success"
         :timeout="4000">
      {{successMessage}}
      </vc-alert>
      <vc-alert v-if="error" type="danger" :dismissible="false">
         Er is een fout opgetreden!
      </vc-alert>
      <div class="table-responsive">
        <div class="card-title card-header form-horizontal">
          <label>Aantal orders: {{total}} </label>
          <div class="form-group">
            <label class="control-label col-sm-1" style="text-align:left;" for="filter">Filter op : </label>
            <div class="col-sm-4">
              <input type="text" class="form-control" id="filter" placeholder="Filter" v-model="filterKey">
            </div>
          </div>
        </div>
        <table class="table table-hover">
          <thead>
            <tr>
              <th v-for="(key, val) in columns">
                <a @click="sortBy(val)" class="arrow" :class="active: sortKey == column">
                  {{ key | capitalize }}
                </a>
              </th>
          </thead>
          <tbody>
            <tr v-for="order in Orders | filterBy filterKey | orderBy sortKey reverse" :class="{ 'success': order.IsActive }">
              <td>
                <p style="white-space:pre-line;"><small>{{ order.CustomerName }}</small></p>
              </td>
              <td>
                <p style="white-space:pre-line;"><small>{{ order.CustomerMail }}</small></p>
              </td>
              <td>
                <p style="white-space:pre-line;"><small>{{ order.Address + ' ' + order.HouseNumber + ', ' + order.ZipCode + ' ' + order.Place}}</small> <small v-if="order.Remark">(Opmerking: {{order.Remark}})</small> </p>
              </td>
              <td>
                <p style="white-space:pre-line;"><small>{{ order.DateSubmitted }}</small></p>
              </td>
              <td>
                <p style="white-space:pre-line;"><small>{{ order.SubTotal | currencyDisplay }}</small></p>
              </td>
              <td>
                <p style="white-space:pre-line;"><small>{{ order.ShipCosts | currencyDisplay }}</small></p>
              </td>
              <td>
                <p style="white-space:pre-line;"><small>{{ (order.SubTotal + order.ShipCosts) | currencyDisplay }}</small></p>
              </td>
<!--               <td>
                <div class="ios">
                  <vui-toggle name="wifi" :checked.sync="order.Approved" @change="setAvailable(order)"></vui-toggle>
                </div>
                <p v-if="order.Approved" class="text-success">Aan</p>
                <p v-else class="text-danger">Verborgen</p>
              </td> -->
              <td width="10%">
                <button type="button" class="btn btn-danger" @click="selectorder(order, 'delete')">Verwijder</button>
                <button type="button" class="btn btn-primary" @click="selectorder(order, 'update')">Wijzig</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<vm-delete :callback.sync="remove" :show.sync="showdeltemodal"></vm-delete>
<v-modal :show.sync="showCustomModal" effect="fade" width="400">
  <div slot="modal-header" class="modal-header">
    <h4 class="modal-title">
      <b>Order aanpassen</b>
    </h4>
  </div>
  <div slot="modal-body" class="modal-body">
    <div class="form-group">
      <label for="custName">Klant gegevens: </label>
      <p id="custName" style="white-space:pre-line;"><small>{{ selectedorder.CustomerName }}</small></p>
      <p style="white-space:pre-line;"><small>{{ selectedorder.CustomerMail }}</small></p>
      <p style="white-space:pre-line;"><small>{{ selectedorder.Address + ' ' + selectedorder.HouseNumber + ', ' + selectedorder.ZipCode + ' ' + selectedorder.Place }}</small>
      <small v-if="order.Remark">(Opmerking: {{order.Remark}})</small></p>
    </div>
    <div class="form-group">
      <label for="subselected">Order details:</label>
      <overzicht :products="selectedorder.Products" :subtotal.sync="selectedorder.SubTotal" :shippingcost.sync="selectedorder.ShipCosts" :totalprice="(selectedorder.SubTotal + selectedorder.ShipCosts)"></overzicht>
      <p id="subselected" style="white-space:pre-line;"><small>{{ selectedorder.SubTotal | currencyDisplay }}</small></p>
      <input type="text" class="form-control" id="selectedorderDesc" v-model="selectedorder.ShipCosts | currencyDisplay">
      <hr>
      <p id="totalselected"><strong>Totaal: </strong>{{ (selectedorder.SubTotal + selectedorder.ShipCosts) | currencyDisplay }}</p>
    </div>
    <div class="form-group">
      <label for="BannerName">Opslaan en mail versturen: </label>
      <label><input type="checkbox" v-model="selectedorder.saved"></label>
    </div>
  </div>
  <div slot="modal-footer" class="modal-footer">
    <button type="button" class="btn btn-success" :disabled="!selectedorder.saved" @click="updateorder()">Opslaan</button>
  </div>
</v-modal>
</template>
<script>
import store from '../../store'
import callbackalert from '../Common/CallbackAlert'
import toggle from '../Common/Toggle'
import deletemodal from '../Common/deleteSweetAlert'
import modal from '../Common/Modal'
import overzicht from '../afterordening/betalen-cart'
export default {
  route: {
    canReuse: false
  },
  components: {
    'vc-alert': callbackalert,
    'vui-toggle': toggle,
    'vm-delete': deletemodal,
    'v-modal': modal,
    overzicht
  },
  data () {
    return {
      store: store,
      Orders: {},
      success: false,
      error: false,
      successMessage: 'order succesvol bijgewerkt!',
      columns: {
        'Klantnaam': 'CustomerName',
        'Email': 'CustomerMail',
        'Adres': 'Address',
        'Datum': 'DateSubmitted',
        'Subtotaal': 'SubTotal',
        'Verzendkosten': 'ShipCosts',
        'Totaal': 'Total',
        // 'Status': 'Enabled',
        ' ': 'Actions'
      },
      sortKey: '',
      reverse: 1,
      showdeltemodal: false,
      selectedorder: null,
      filterKey: '',
      showCustomModal: false,
      edit: false
    }
  },
  created () {
    this.getOrders()
  },
  methods: {
    getOrders: function () {
      $.ajax({
        type: 'GET',
        url: store.root + 'api/invoices',
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        },
        success: function (response) {
          this.Orders = response
        }.bind(this)
      })
    },
    remove: function () {
      console.log('Verwijderen~!')
      $.ajax({
        type: 'DELETE',
        url: store.root + 'api/Invoices/' + this.selectedorder.Id,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        this.success = true
        this.error = false
        this.Orders.$remove(this.selectedorder)
        this.selectedorder = null
        this.showdeltemodal = false
        console.log('Verwijderd~!')
      }.bind(this))
      .fail(function (response) {
        console.log(response)
        this.success = false
        this.error = true
      }.bind(this))
    },
    sortBy: function (sortKey) {
      this.reverse = (this.sortKey === sortKey) ? this.reverse * -1 : -1
      this.sortKey = sortKey
    },
    setAvailable: function (item) {
      $.ajax({
        type: 'PUT',
        url: store.root + 'api/invoices/' + item.Id,
        data: item,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        this.success = true
        console.log('change Available succesfully done!')
      })
      .fail(function (response) {
        console.log(response)
      })
    },
    selectorder: function (val, type) {
      this.selectedorder = val
      if (type === 'delete') {
        this.showdeltemodal = true
      } else {
        this.showCustomModal = true
      }
    },
    updateorder: function () {
      $.ajax({
        type: 'PUT',
        url: store.root + 'api/Invoices/' + this.selectedorder.Id,
        data: this.selectedorder,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        this.success = true
        this.error = false
        this.edit = false
        this.selectedorder = null
        this.showCustomModal = false
      }.bind(this))
      .fail(function (response) {
        console.log(response)
        this.error = true
        this.success = false
      }.bind(this))
    }
  },
  computed: {
    total: function () {
      return this.Orders.length
    }
  }
}
</script>


// WEBPACK FOOTER //
// order-overzicht.vue?12d6d339